/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import {
  CommunityGalleriesGetOptionalParams,
  CommunityGalleriesGetResponse,
} from "../models/index.js";

/** Interface representing a CommunityGalleries. */
export interface CommunityGalleries {
  /**
   * Get a community gallery by gallery public name.
   * @param location The name of Azure region.
   * @param publicGalleryName The public name of the community gallery.
   * @param options The options parameters.
   */
  get(
    location: string,
    publicGalleryName: string,
    options?: CommunityGalleriesGetOptionalParams,
  ): Promise<CommunityGalleriesGetResponse>;
}
